import { useContext } from 'react';

import { RoleActionContext, RoleValueContext } from './context';

const useRoleValue = () => {
  const context = useContext(RoleValueContext);
  if (!context) {
    throw new Error('useRoleValue must be used within a <RoleFormContext />');
  }
  return context;
};

const useRoleAction = () => {
  const context = useContext(RoleActionContext);
  if (!context) {
    throw new Error('useRoleAction must be used within a <RoleFormContext />');
  }
  return context;
};

export { useRoleAction, useRoleValue };
